export function downsampleBuffer(buffer, sampleRate, outSampleRate) {
    if (outSampleRate == sampleRate) {
        return buffer;
    }
    if (outSampleRate > sampleRate) {
        throw 'downsampling rate show be smaller than original sample rate';
    }
    var sampleRateRatio = sampleRate / outSampleRate;
    var newLength = Math.round(buffer.length / sampleRateRatio);
    var result = new Int16Array(newLength);
    var offsetResult = 0;
    var offsetBuffer = 0;
    while (offsetResult < result.length) {
        var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
        var accum = 0,
            count = 0;
        for (var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
            accum += buffer[i];
            count++;
        }

        result[offsetResult] = Math.min(1, accum / count) * 0x7fff;
        offsetResult++;
        offsetBuffer = nextOffsetBuffer;
    }
    return result.buffer;
}

export function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}

export const waitForOpenConnection = (socket) => {
    return new Promise((resolve, reject) => {
        const maxNumberOfAttempts = 30
        const intervalTime = 500 //ms

        let currentAttempt = 0
        const interval = setInterval(() => {
            if (currentAttempt > maxNumberOfAttempts - 1) {
                clearInterval(interval)
                reject(new Error('Maximum number of attempts exceeded'))
            } else if (socket.readyState === socket.OPEN) {
                clearInterval(interval)
                resolve()
            }
            currentAttempt++
        }, intervalTime)
    })
}
export const sendMessage = async (socket, msg) => {
    if (socket.readyState !== socket.OPEN) {
        try {
            await waitForOpenConnection(socket)
            socket.send(msg)
        } catch (err) {
            console.error(err)
        }
    } else {
        socket.send(msg)
    }
}

export function mergeMsg(conversation, setConversation) {
    let convo = [...conversation]
    const len = convo.length
    if (len === 0) return
    if (len === 1) {
        return
    }
    const msg = conversation[len - 1]
    // console.log("CONVOLEN", len, convo[len-1])
    const {status, text, idx, is_block, answer} = msg
    if (answer) {
        return
    }
    if (!convo[len - 1].is_block) {
        const last = convo.pop()
        let pos = 2
        while (len - pos >= 0 && convo[len - pos].answer !== undefined) {
            pos += 1
        }
        // console.log("POS_1", pos, last)
        if (convo[len - pos].idx === last.idx) {
            convo[len - pos].text = convo[len - pos].text + "\n" + last.text
            setConversation(convo)
        }
        return
    }
    if (convo[len - 1].is_block) {
        const last = convo.pop()
        let pos = 2
        while (len - pos >= 0 && convo[len - pos].answer !== undefined) {
            pos += 1
        }
        // console.log("POS_2", pos, last)
        if (convo[len - pos].idx === last.idx) {
            convo[len - pos] = last
            setConversation(convo)
        }

    }

}


export function getStorageValue(key, defaultValue, callback) {
  const saved = localStorage.getItem(key);
  let initial = null;
  try {
      initial = saved !== null ? JSON.parse(saved) : defaultValue;
  }
  catch {
      return null;
  }
  callback(initial);
  return initial;
}
